"use client";

import { DirectusImage } from "@/components/DirectusImage";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogTrigger,
} from "@/components/ui/dialog";
import { cn } from "@/lib/utils";

import { Image as ImageIcon, X } from "lucide-react";
import { useState } from "react";

export default function DisplayImage(props: {
  images?: string[];
  material_number?: string;
}) {
  const [current, setCurrent] = useState(0);

  return (
    <Dialog>
      <DialogTrigger asChild>
        <ImageIcon className="cursor-pointer text-primary transition-colors duration-300 hover:text-opacity-80" />
      </DialogTrigger>
      <DialogContent className="h-[90vh] w-[90vw] max-w-none border-none bg-white p-0 outline-none">
        <div className="flex h-full w-full flex-col">
          <div className="flex h-20 flex-shrink-0 items-center justify-between border-b border-[#e8e8e8] px-5">
            <h3 className="text-2xl">{props.material_number}</h3>

            <DialogClose>
              <div className="cursor-pointer transition-colors duration-300 hover:text-primary">
                <X />
              </div>
            </DialogClose>
          </div>
          <div className=" relative flex flex-1 p-8">
            <div className="flex h-full w-full items-center justify-center">
              {props.images?.[current] && (
                <DirectusImage
                  id={props.images?.[current]}
                  alt=""
                  fill
                  className="max-h-full max-w-full object-scale-down object-center"
                />
              )}
            </div>
          </div>
          <div className="flex h-32 flex-shrink-0 items-center justify-center space-x-5 pb-8">
            {props.images?.map((item, index) => (
              <div
                key={index}
                className={cn(
                  "relative flex h-28 w-28 items-center justify-center border border-[#cccccc] transition-colors duration-300 hover:border-primary",
                  {
                    "border-primary": current === index,
                  }
                )}
                onClick={() => setCurrent(index)}>
                <DirectusImage
                  id={item}
                  alt=""
                  fill
                  className="w-full object-scale-down object-center"
                />
              </div>
            ))}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
